import { ComponentsOverrides, ComponentsProps, ComponentsVariants, Theme, alpha } from '@mui/material';
import { IEBreakPoints } from 'theme/@types';
import fontsConfig from 'theme/fonts';

interface IMuiAccordion {
  defaultProps?: ComponentsProps['MuiAccordion'];
  styleOverrides?: ComponentsOverrides<Theme>['MuiAccordion'];
  variants?: ComponentsVariants<Theme>['MuiAccordion'];
}

const MuiAccordionConfig: IMuiAccordion = {
  defaultProps: {
    variant: 'light',
  },
  variants: [
    {
      props: {
        variant: 'light',
      },
      style: ({ theme }) => ({
        height: 'auto',
        '&.MuiAccordion-root': {
          '&.Mui-disabled': {
            backgroundColor: theme.palette.transparent.main,
          },
        },
        '.MuiAccordionSummary-root': {
          borderBottom: `1px solid ${theme.palette.sixth.light}`,
          margin: 0,
          minHeight: 'auto',
          paddingRight: 19,
          paddingLeft: 0,
          paddingTop: 10,
          paddingBottom: 10,

          '&.Mui-expanded': {
            minHeight: 'auto',
          },

          '.MuiAccordionSummary-content': {
            margin: 0,
            fontSize: 30,

            '.MuiTypography-root': {
              fontSize: fontsConfig.sizes.defaultS,
              fontWeight: fontsConfig.weights.SemiBold,
            },

            'MuiAccordionSummary-expandIconWrapper': {},
          },
        },
        '.MuiCollapse-root': {
          marginTop: 20,

          '.MuiAccordionDetails-root': {
            padding: 0,
          },
        },

        [theme.breakpoints.up(IEBreakPoints.LAPTOP)]: {
          '.MuiAccordionSummary-root': {
            margin: 0,
            minHeight: 'auto',
            '.MuiAccordionSummary-content': {
              '.MuiTypography-root': {
                fontSize: fontsConfig.sizes.defaultL,
              },
            },
          },
          '.MuiCollapse-root': {
            marginTop: 30,
          },
        },
      }),
    },
    {
      props: {
        variant: 'outlined',
      },
      style: ({ theme }) => ({
        height: 'auto',
        '&.MuiAccordion-root': {
          borderRadius: 8,
          marginBottom: 20,
          border: 'none',
          boxShadow: '0px 0px 10px 0px #00000026',

          '&:before': {
            display: 'none',
          },
        },
        '.MuiAccordionSummary-root': {
          margin: 0,
          minHeight: 'auto',
          padding: '8px 10px 7px 10px',

          '.MuiAccordionSummary-expandIconWrapper': {
            borderRadius: '50%',
            backgroundColor: alpha(theme.palette.primary.main, 0.2),
          },

          '.MuiAccordionSummary-content': {
            margin: 0,
          },

          // '&.Mui-expanded': {
          //   minHeight: 'auto',
          // },
        },
        '.MuiCollapse-root': {
          marginTop: 5,

          '.MuiAccordionDetails-root': {
            padding: '10px 20px',
          },
        },
      }),
    },
  ],
  styleOverrides: {
    root: {},
  },
};

export default MuiAccordionConfig;
